import { createStyles } from '@material-ui/styles';
import palette from 'theme/palette';

export default () =>
  createStyles({
    rootTabs: {
      width: '100%',
      borderBottom: `1px solid ${palette.lightGray}`,
    },

    tabsYellow: {
      minHeight: 40,
      '& .MuiTabs-indicator': {
        background: palette.navCompanyContextActions,
      },
    },
    tabsGreen: {
      minHeight: 40,
      '& .MuiTabs-indicator': {
        background: palette.navAdminActions,
      },
    },
    tabsGray: {
      minHeight: 40,
      '& .MuiTabs-indicator': {
        background: palette.navSuperAdminActions,
      },
    },
    tabsBlue: {
      minHeight: 40,
      '& .MuiTabs-indicator': {
        background: palette.navOperatorActions,
      },
    },
    iconReport: {
      marginRight: 12,
      fontSize: 14,
      marginBottom: '0px !important',
    },
    iconFormat: {
      background: palette.deepBlue,
      color: palette.white,
      borderRadius: '50%',
      padding: 6,
      transform: 'scale(.7)',
    },

    tabYellow: {
      fontSize: 12,
      fontWeight: 500,
      minHeight: 35,
      alignItems: 'end',
      color: palette.darkGray,

      '&:hover': {
        textDecoration: 'none',
      },

      '&.Mui-selected': {
        color: palette.navCompanyContextActions,
      },

      '& .MuiTab-wrapper': {
        flexDirection: 'row',
        alignItems: 'none',
      },
    },
    tabGreen: {
      fontSize: 12,
      fontWeight: 500,
      minHeight: 35,
      alignItems: 'end',
      color: palette.darkGray,

      '&:hover': {
        textDecoration: 'none',
      },

      '&.Mui-selected': {
        color: palette.navAdminActions,
      },

      '& .MuiTab-wrapper': {
        flexDirection: 'row',
        alignItems: 'none',
      },
    },
    tabGray: {
      fontSize: 12,
      fontWeight: 500,
      minHeight: 35,
      alignItems: 'end',
      color: palette.darkGray,

      '&:hover': {
        textDecoration: 'none',
      },

      '&.Mui-selected': {
        color: palette.navSuperAdminActions,
      },

      '& .MuiTab-wrapper': {
        flexDirection: 'row',
        alignItems: 'none',
      },
    },
    tabBlue: {
      fontSize: 12,
      fontWeight: 500,
      minHeight: 35,
      alignItems: 'end',
      color: palette.darkGray,

      '&:hover': {
        textDecoration: 'none',
      },

      '&.Mui-selected': {
        color: palette.navOperatorActions,
      },

      '& .MuiTab-wrapper': {
        flexDirection: 'row',
        alignItems: 'none',
      },
    },

    tabPanelContent: {
      width: '100%',
      minWidth: 750,
      '& .MuiFormLabel-root.Mui-disabled': {
        fontSize: 12,
      },
    },
    deleteButtonIcon: { fontSize: '16px !important' },
    content: {
      marginTop: 48,
    },
    checkboxCell: {
      width: '10%',
      padding: '0 0 0 8px',
      justifyContent: 'center',

      '& .MuiCheckbox-root': {
        padding: 0,
      },

      '& span > span > svg': { width: 15, height: 15 },
    },
    rowAllRows: {
      width: '55%',
      fontSize: 12,
    },
    rowAllRowsClient: {
      width: '35%',
      fontSize: 12,
    },
    rowAllRowsPlatform: {
      width: '45%',
      fontSize: 12,
    },
    rowAllRowsCount: {
      width: '20%',
      fontSize: 12,
      justifyContent: 'center',
      textAlign: 'center',
    },
    rowAllRowsCountClient: {
      width: '35%',
      fontSize: 12,
      justifyContent: 'center',
      textAlign: 'center',
    },
    statusHeader: {
      width: '20%',
      justifyContent: 'center',
      fontSize: 12,
      paddingLeft: '22px !important',
    },
    actionHeader: {
      width: '10%',
      justifyContent: 'center',
      textAlign: 'center',
    },
    removeAppButton: {
      color: palette.error.light,
      padding: 0,
      '& svg': {
        width: 16,
        height: 16,
      },
    },
    searchInput: {
      width: '100%',
      fontSize: 14,
      color: palette.darkGray,
    },
    changeAccountContainer: { padding: 15, alignItems: 'center' },
    currentAccount: {
      fontWeight: 'bold',
      fontSize: 14,
      color: palette.blue,
    },
    newAccount: {
      fontWeight: 'bold',
      fontSize: 14,
      color: palette.green,
    },
    accountName: { fontSize: 16 },
    arrow: {
      position: 'absolute',
      top: '47%',
      left: '40%',
      transform: 'translate(-50%, -50%) rotate(270deg)',
      cursor: 'pointer',

      '& span': {
        display: 'block',
        width: '10px',
        height: '10px',
        borderBottom: `2px solid ${palette.green}`,
        borderRight: `2px solid ${palette.green}`,
        transform: 'rotate(45deg)',
        margin: '-10px',
        animation: '$arrow 2s infinite',
      },

      '& span:nth-child(2)': {
        animationDelay: '-0.2s',
      },
      '& span:nth-child(3)': {
        animationDelay: '-0.4s',
      },
    },
    '@keyframes arrow': {
      '0%': {
        opacity: '0',
        transform: 'rotate(45deg) translate(-20px, -20px)',
      },
      '50%': {
        opacity: '1',
      },
      '100%': {
        opacity: '0',
        transform: 'rotate(45deg) translate(20px, 20px)',
      },
    },
    actionsHeader: { marginBottom: 16 },
    warn: { color: palette.deepBlue, width: 30, height: 30 },
    warnText: { fontSize: 12 },
    addButtonIcon: {
      fontSize: '20px !important',

      '& .MuiButton-startIcon': {
        marginRight: 2,
      },
    },
    addButton: { alignItems: 'center', display: 'flex' },
    buttons: { marginTop: 16 },
    detailCard: {
      padding: 8,
      borderRadius: 8,
      boxShadow: '0px 1px 30px 0px rgba(0, 0, 0, 0.05)',
      border: '1px solid #E9EAEC',
      marginBottom: 16,
    },
    titleCard: {
      margin: 16,
      fontSize: 16,
      color: palette.blue,
      fontWeight: 'bold',
    },
    text: { fontSize: 12 },
    detailsGrid: { marginLeft: 8, display: 'block' },
    editButton: { marginBottom: 8 },
    button: {
      margin: 0,
      border: `1px solid ${palette.blue}`,
      color: palette.blue,
    },
    titleSection: {
      fontSize: 16,
      color: palette.darkGray,
      fontWeight: 'bold',
    },
    availableLicenses: { marginLeft: 8 },
    alert: {
      marginTop: 8,
      fontSize: 12,
      maxWidth: 700,

      '& b': {
        fontWeight: 900,
      },
    },
    alertText: { fontSize: 14 },
  });

export const overrideModal = {
  content: {
    padding: 12,
    fontSize: '12px !important',
    maxHeight: '100%',
    overflowX: 'auto',
  },
};
